import {useEffect} from 'react'

export const useWillUnmount = (func) => {
    useEffect(() => {
        return func
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
}